import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { EMAIL_ENDPOINT } from '../constants/endpoints';
export function validateEmail(email) {
  return noAuthApiClient.get(`${EMAIL_ENDPOINT}/${email}/validate`, {
    withCredentials: false
  });
}